import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AgentSkillEditorProvider } from "@/components/agents/agent-skill-context";

export const Route = createFileRoute("/$owner/agents/$agentId/skills")({
	component: AgentSkillsLayout,
});

function AgentSkillsLayout() {
	const { agentId } = Route.useParams();
	return (
		<AgentSkillEditorProvider agentId={agentId}>
			<Outlet />
		</AgentSkillEditorProvider>
	);
}